import { faLock } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Input } from '@orobix/orobix-fe-components'

import { ProductType } from '../../../types'
import useStyles from './ResolutionSelect.styles'

export interface ResolutionInputRangeProps {
  customHeight: number
  customWidth: number
  setCustomHeight: React.Dispatch<React.SetStateAction<number>>
  setCustomWidth: React.Dispatch<React.SetStateAction<number>>
  getResolutionsErrorMessage: (
    arg0: number,
    arg1: number,
    arg3: number,
    productType: ProductType,
    t: (arg0: string, arg1?: object) => string
  ) => string
  maxResolution: number
  step: number
  productType: ProductType
  t: (arg0: string, arg1?: object) => string
  onResolutionInputRangeChange?: (newHeight: number, newWidth: number) => void
}

const ResolutionInputRange = ({
  customHeight,
  customWidth,
  setCustomHeight,
  setCustomWidth,
  getResolutionsErrorMessage,
  maxResolution,
  step,
  productType,
  t,
  onResolutionInputRangeChange,
}: ResolutionInputRangeProps) => {
  const MIN_RES = 64
  const MAX_RES = 1024
  const styles = useStyles()

  return (
    <div>
      <div className={styles.resolutionInputDiv}>
        <Input
          name="height"
          label={t('Height')}
          id="heightId"
          type="number"
          step={step}
          value={customHeight}
          onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
            e.target.select()
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setCustomHeight(Number(e.target.value))
            if (onResolutionInputRangeChange) {
              onResolutionInputRangeChange(Number(e.target.value), customWidth)
            }
          }}
          min={MIN_RES}
          max={MAX_RES}
          title={t(
            'Value must be between {{ minResolution }} and {{ maxResolution }}',
            { minResolution: MIN_RES, maxResolution: MAX_RES }
          )}
        />
        <FontAwesomeIcon
          title={t('Height and Width are strictly dependent')}
          icon={faLock}
          className={styles.icon}
        />
        <Input
          name="width"
          label={t('Width')}
          id="widthId"
          type="number"
          step={step}
          value={customWidth}
          onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
            e.target.select()
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setCustomWidth(Number(e.target.value))
            if (onResolutionInputRangeChange) {
              onResolutionInputRangeChange(Number(e.target.value), customWidth)
            }
          }}
          min={MIN_RES}
          max={MAX_RES}
          title={t(
            'Value must be between {{ minResolution }} and {{ maxResolution }}',
            { minResolution: MIN_RES, maxResolution: MAX_RES }
          )}
        />
      </div>
      <div>
        <output
          className={
            getResolutionsErrorMessage(
              customHeight,
              customWidth,
              maxResolution,
              productType,
              t
            ) === ''
              ? styles.resolutionErrorHide
              : styles.resolutionErrorShow
          }
          name="heightResult"
          htmlFor="height"
        >
          {getResolutionsErrorMessage(
            customHeight,
            customWidth,
            maxResolution,
            productType,
            t
          )}
        </output>
      </div>
    </div>
  )
}

export default ResolutionInputRange
